import { render, staticRenderFns } from "./MainContentCard.vue?vue&type=template&id=02989bb5&scoped=true&"
import script from "./MainContentCard.vue?vue&type=script&lang=js&"
export * from "./MainContentCard.vue?vue&type=script&lang=js&"
import style0 from "./MainContentCard.vue?vue&type=style&index=0&id=02989bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02989bb5",
  null
  
)

export default component.exports